<template>
  <div class="h-full">
    <div class="text-right mb-4 flex flex-row">
      <BaseInput @input="debounceSearch" :value="search" placeholder="Sök" />
      <div class="ml-4">
        <button class="btn btn-primary" @click="create">
          Ny Produkt
        </button>
      </div>
    </div>
    <ApolloQuery
      :query="require('../../graphql/Products.gql')"
      :variables="{ search }"
    >
      <template
        slot-scope="{ result: { loading, error, data, refetch }, isLoading }"
      >
        <!-- Loading -->
        <div v-if="isLoading" class="w-full text-center pt-16">
          <b-spinner class="align-middle"></b-spinner>
        </div>

        <!-- Error -->
        <div v-else-if="error" class="error apollo">Ett fel inträffade</div>

        <!-- Result -->
        <div v-else-if="data" class="result apollo">
          <b-table
            hover
            striped
            :fields="fields"
            :items="data.products"
            @row-clicked="details"
          ></b-table>
        </div>

        <!-- No result -->
        <div v-else class="no-result apollo">Inga företag hittades :(</div>
      </template>
      <!-- <transition name="fade">
        <div class="modal-container" v-if="isOpen" @click.self="close">
          <router-view @refresh="refetch()" />
        </div>
      </transition> -->
    </ApolloQuery>
    <!--  <modal
      name="create-product"
      transition="pop-out"
      :pivotY="0.2"
      height="auto"
      adaptive
    >
      <div class="p-3">
        <div class="text-right mt-5">
          <button
            class="btn btn-default"
            @click="$modal.hide('create-product')"
          >
            Avbryt
          </button>
          <button class="btn btn-primary" @click="handleSubmit">
            Spara
          </button>
        </div>
      </div>
    </modal> -->
  </div>
</template>

<script>
import { useQuery, useResult, useMutation } from '@vue/apollo-composable'
import { ref, reactive, watch, toRefs } from '@vue/composition-api'
export default {
  setup(props, { root }) {
    const state = reactive({
      debounce: null,
      search: '',
      fields: [
        {
          key: 'title',
          label: 'Produktnamn',
        },
        {
          key: 'barcode',
          label: 'Streckkod',
        },
        {
          key: 'size',
          label: 'Storlek',
        },
        {
          key: 'weight',
          label: 'Vikt',
        },
      ],
    })

    function details(row) {
      root.$router.push({
        name: 'product.details',
        params: { id: row.id },
      })
    }

    function debounceSearch(event) {
      clearTimeout(state.debounce)

      state.debounce = setTimeout(() => {
        state.search = event
      }, 600)
    }

    const create = () =>
      root.$router.push({
        name: 'product.create',
      })

    return { details, debounceSearch, create, ...toRefs(state) }
  },
}
</script>
